import { Activity, UserCheck } from "lucide-react";

export const getStatusIcon = (status: string) => {
  const lower = status.toLowerCase();
  if (lower === "present") {
    return <UserCheck className="h-3 w-3 mr-1" />;
  } else {
    return <Activity className="h-3 w-3 mr-1 text-gray-400" />;
  }
};

export const getStatusBadge = (status: string) => {
  const lower = status.toLowerCase();
  if (lower === "present") {
    return "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold transition-all duration-200 bg-emerald-50 text-emerald-700 border border-emerald-200";
  }
};

export const getStatusColor = (status: string) => {
  const lowerStatus = status?.toLowerCase();
  if (lowerStatus) {
    return "text-emerald-600";
  }
};

export const formatTime = (dateString: string) => {
  return new Date(dateString).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatLocation = (location: { lat: number; lng: number }) => {
  return `${location.lat.toFixed(4)}, ${location.lng.toFixed(4)}`;
};

export const isWeekend = (
  date: Date,
  weekendPolicy: "general_sat_sun_off" | "general_sun_off_only"
): boolean => {
  const day = date.getDay(); // 0 = Sunday, 6 = Saturday

  if (weekendPolicy === "general_sat_sun_off") {
    return day === 0 || day === 6;
  }
  if (weekendPolicy === "general_sun_off_only") {
    return day === 0;
  }
  return false;
};